<template>
  <div>
    <b-row
      class="m-1 d-flex justify-content-between align-items-center"
    >
      <b-col
        class="text-left"
        md="3"
        lg="3"
      >
        <copy-snippet
          snippet-id="copy-bc-case-id"
          label="BC CASE ID"
          :value="bcCaseId ? bcCaseId.toString() : 'N/A'"
        />
        <copy-snippet
          snippet-id="copy-case-id"
          label="CASE ID"
          :value="prefixCaseId ? prefixCaseId : caseId"
        />
      </b-col>
      <b-col
        v-if="(caseStatus === 0 ||caseStatus === 1) && isPlanActive === 1"
        md="2"
        lg="2"
      >
        <b-alert
          class="alert-custom"
          show
        >
          <div class="alert-body">
            <span>{{ $t('DEBTIA_INSTALLMENT_ALERT') }}</span>
          </div>
        </b-alert>
      </b-col>
      <b-col
        class="text-right"
        :md="(caseStatus === 0 ||caseStatus === 1) && isPlanActive === 1 ? 6 : 9"
        :lg="(caseStatus === 0 ||caseStatus === 1) && isPlanActive === 1 ? 6 : 9"
      >
        <b-button-group>
          <header-buttons
            :bc-case-id="bcCaseId"
            :case-status="caseStatus"
            :case-state-data="caseStateData"
            :case-state="caseState"
            :is-fully-paid-active="isFullyPaidActive"
            :restrict-full-payment-actions="restrictFullPaymentActions"
          />
        </b-button-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
  BButtonGroup,
  BAlert,
} from 'bootstrap-vue'
// import store from '@/store'
import CopySnippet from './CopySnippet.vue'
import HeaderButtons from './HeaderButtons.vue'

export default {
  components: {
    BRow,
    BCol,
    CopySnippet,
    HeaderButtons,
    BButtonGroup,
    BAlert,
  },
  // setup() {
  //   const {
  //     bcCaseId, caseId, caseStatus, prefixCaseId,
  //   } = store.state['case-details']
  //   return {
  //     bcCaseId,
  //     caseId,
  //     caseStatus,
  //     prefixCaseId,
  //   }
  // },
  props: {
    bcCaseId: {
      type: String,
      required: true,
    },
    caseStatus: {
      type: Number,
      required: true,
    },
    prefixCaseId: {
      type: [String, null],
      required: true,
    },
    caseStateData: {
      type: Object,
      required: true,
    },
    caseState: {
      type: String,
      required: true,
      default: '',
    },
    isPlanActive: {
      type: Number,
      required: true,
    },
    isFullyPaidActive: {
      type: Boolean,
      default: false,
    },
    restrictFullPaymentActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      caseId: this.$route.params.id,
    }
  },
}
</script>

<style lang="scss">
.alert-custom {
  background-color: #00A2E8 !important;
  color: white  !important;
  text-align: center !important;
}
</style>
